<template>
  <label class="chip-wrap day" :class="[border, bg, ftcolor, disabled]" @click="clickChip">
    <slot name="chipname"></slot>
  </label>
</template>
<script>
import ChipComponent from './ChipComponent.vue';
export default {
  extends: ChipComponent,
  props: {
    disabled: {
      type: String,
      default: '',
      required: false
    }
  }
};
</script>
<style scoped src="@/assets/css/chipcomponent/chipcomponent.css"></style>
